export default __webpack_public_path__ + "static/media/Unicef.4c4b1016.jpg";